module.exports = __webpack_public_path__ + "static/asiyanbi-00e4d3cac534477ac4c653926168423d.png";